import HomeScreen from './containers/HomeScreen/index';
import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import { t } from '../../locales';
import homeSaga from './saga/homeSaga';
import { init } from '../ps-popup';
import { muleCustStateSaga } from './saga/muleCustStateSaga';
import muleCustStateReducer from './reducers/muleCustStateReducer';
import { withLoadingWidgetHoc } from '../../components/lazyLoading/with-loading-widget-hoc';
init();

export default {
  config,
  routes: {
    '': {
      exact: true,
      sidebarItem: {
        label: t('HOME_LABEL'),
        iconDefault: `/assets/images/home.svg`,
        iconSelected: `/assets/images/home-selected.svg`,
        priority: 100,
        excludedRoutes: ['/home/life/portal/emma/generic-support'],
      },
      container: withLoadingWidgetHoc(HomeScreen),
    },
  },
  reducers: {
    muleCustState: {
      reducer: muleCustStateReducer,
    },
  },
  sagas: [homeSaga, muleCustStateSaga],
} as ModuleConfig;
